import { WidgetViewModeUtils } from 'utilitys/reporting/widgetViewModeUtils';

import { useGraphAnnotationStore } from 'store/graphAnnotation.store';
import { useThemeStatusStore } from 'store/themeStatus.store';

import { ProgressMeasurement } from 'components/common/GlobalFiltersInPage/components/progressMeasurementFilter/progressMeasurementFilter';

import { useUpdateIfReady } from 'components/Dashboards/Reporting/widgetInReport/hooks/RefreshWidgetPayload/useUpdateIfReady';
import { getPoints, serializeData, serializeOptions } from 'components/widgets/SCurve/Scurve.utils';

const FILTER_LIST: ProgressMeasurement[] = [
    'activityCompleted',
    'activityCompletedCriticality',
    'activitySubmittedCompletion',
    'activitySubmittedCompletionCriticality',
];

const CHART_HEIGHT_IN_REPORT_VIEW = '100%';
const CHART_HEIGHT_IN_PAGE_VIEW = 600;

export const useScurveLogic = ({ ui, api, widgetViewMode, setIsPayloadReady }) => {
    const isPayloadReady = () => {
        const currentPayload = api.scurveGraph.payload;
        if (!currentPayload) return;
        if (
            currentPayload.actualMetaDataId === undefined ||
            currentPayload.baselineMetaDataId === undefined ||
            currentPayload.graphType === undefined ||
            currentPayload.isPartialCompletion === null
        ) {
            return;
        }
        setIsPayloadReady && setIsPayloadReady(true);
    };

    const { data, isFetching } = api.scurveGraph.instance;
    const sourceData = ui.state;
    const isShowCriticalityAnnotation = useGraphAnnotationStore((store) => store.isShowCriticalityAnnotation);
    const { update } = useGraphAnnotationStore();
    const { themeStatus } = useThemeStatusStore();
    useUpdateIfReady({ isPayloadReadyCallback: isPayloadReady, widgetViewMode: widgetViewMode });
    const pointsAnnotation = getPoints(data);
    const series = serializeData(data);
    const options = serializeOptions({
        series,
        nowDate: data?.nowDate,
        themeStatus,
        isShowAnnotation: isShowCriticalityAnnotation,
        pointsAnnotation,
    });

    const noResults =
        !isFetching && data?.plannedGraphLine?.data?.length === 0 && data?.actualGraphLine?.data?.length === 0;

    const notApplicable =
        FILTER_LIST.includes(sourceData?.progressMeasurement) &&
        Boolean(sourceData?.resourceType?.length > 0 || sourceData?.resource);

    const noDataCondition = noResults || notApplicable;

    const chartHeight = WidgetViewModeUtils.isReportView(widgetViewMode)
        ? CHART_HEIGHT_IN_REPORT_VIEW
        : CHART_HEIGHT_IN_PAGE_VIEW;

    return {
        logic: {
            noDataCondition,
            options,
            update,
            isShowCriticalityAnnotation,
            series,
            notApplicable,
            chartHeight,
        },
    };
};
